module.exports = __webpack_public_path__ + "static/media/4.903b0ccb.jpg";